import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/home/CategorySection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/home/HomeCarouselSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/home/OriginSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PopularUserDestinationsCarousel"] */ "/app/components/home/popular-destinations/PopularUserDestinationsCarousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/home/QuickSearch.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/home/ReserveSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/home/StorySection.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.3.8_@babel+core@7.29.7_@opentelemetry+api@1.9.1_react-dom@19.2.8_react@19.2.8__react@19.2.8/node_modules/next/dist/client/image-component.js");
